<template>
  <div class="cw-summarized-item" :style="{ 'z-index': this.zindex }">
    <div class="cw-summarized-item-name">{{ this.name }}</div>
    <div class="cw-summarized-item-summary" v-if="this.hasSummaryHtml" v-html="this.summaryHtml"></div>

    <button class="cw-summaryOptionButton" @click="this.select"> {{ this.buttonText }}</button>
  </div>
</template>

<script lang="ts">

import { jsonProxy } from "@/helpers/jsonProxy";
import useAppStore from "@/store/app";

import { ReplyOptionsData, SummarizedItemOptionData } from "@/TickApi";
import { Component, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";

@Component({
  emits: [],
  components: {},
})
export default class SummarizedItemOption extends Vue {
  @Prop() private data!: ReplyOptionsData;
  @Prop() private index!: number;

  private get zindex(): number {
    return 1000 - this.index;
  }

  private get optionsData(): SummarizedItemOptionData {
    return jsonProxy<SummarizedItemOptionData>(this.data.data || "{}", (json) => {
      //do nothing
    });
  }

  private get buttonText() {
    return this.optionsData.buttonText || "";
  }

  private get name() {
    return this.optionsData.name || "";
  }

  private get hasSummaryHtml() {
    return this.summaryHtml && this.summaryHtml.length;
  }

  private get summaryHtml() {
    return this.optionsData.summaryHtml || "";
  }


  private select() {
    useAppStore().replyOptionCallback(this.optionsData.value)

  }

}
</script>

<style lang="scss" scoped>
@import "@/styles/theme";

.cw-summarized-item {
  // &:first-child {
  //   margin-top: 20px;
  // }

  &:last-child {
    margin-bottom: 2vw;
  }

  .cw-summarized-item-name {
    font-size: 1.2em;
    font-weight: 600;

  }

  .cw-summarized-item-summary {
    font-style: italic;
    opacity: 0.8;
  }

  .cw-summaryOptionButton {
    cursor: pointer;
    display: flex;
    width: auto;
    line-height: 24px;
    padding: 4px 16px;
    transition: background-color 120ms ease;
    align-items: center;

    background: var(--cw-conversation-message-actions-bg-color);
    color: var(--cw-conversation-message-actions-fg-color);
    border: solid var(--cw-conversation-message-actions-border-width) var(--cw-conversation-message-actions-border-color);
    border-radius: var(--cw-conversation-message-actions-border-radius);
    box-shadow: var(--cw-conversation-message-actions-drop-shadow);
  }
}

// /* For Mobile */
// @media screen and (hover: none) and (orientation:portrait),
// screen and (max-width: 800px) {

//   .cw-summaryOptionButton {
//     padding: 20px 16px !important;
//   }
// }</style>